<template>
  <baidu-map
    :center="center"
    :zoom="zoom"
    @ready="handler"
    style="height: 400px"
    @click="getClickInfo"
    :scroll-wheel-zoom="true"
  >
  </baidu-map>
</template>
<script>
export default {
  name: 'TestBaiDu',
  data () {
    return {
      center: {lng: 104.148755, lat: 30.657434},
      zoom: 13
    }
  },
  methods: {
    handler ({BMap, map}) {
      var point = new BMap.Point('104.148755', '30.657434')
      map.centerAndZoom(point,20)
      
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
     var content = '<div style="margin:0;line-height:20px;padding:2px;">' +
                    '<img src="../img/baidu.jpg" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>' +
                    '地址：成都市成华区槐树店40号<br/>电话：(010)59928888<br/>简介：韩艺轩医院' +
                  '</div>';

    //创建检索信息窗口对象
    var searchInfoWindow = null;
	// searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
	// 		title  : "韩艺轩医院",      //标题
	// 		width  : 290,             //宽度
	// 		height : 105,              //高度
	// 		panel  : "panel",         //检索结果面板
	// 		enableAutoPan : true,     //自动平移
	// 		searchTypes   :[
	// 			BMAPLIB_TAB_SEARCH,   //周边检索
	// 			BMAPLIB_TAB_TO_HERE,  //到这里去
	// 			BMAPLIB_TAB_FROM_HERE //从这里出发
	// 		]
	// 	});
    var marker = new BMap.Marker(point); //创建marker对象
    // marker.enableDragging(); //marker可拖拽
    marker.addEventListener("click", function(e){
	    searchInfoWindow.open(marker);
    })
    map.addOverlay(marker); //在地图中添加marker
      // var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
      // map.addOverlay(circle)
    },
    getClickInfo (e) {
      console.log(e.point.lng)
      console.log(e.point.lat)
      // this.center.lng = e.point.lng
      // this.center.lat = e.point.lat
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/map.vue